import { Component, OnInit, Input, } from '@angular/core';
import { 
    IonIcon
} from '@ionic/angular/standalone';

function toStringInput(value: any): string {
     return value?.toString() || '';
}

@Component({
    selector: 'marv-field',
    templateUrl: './field.component.html',
    styleUrls: ['./field.component.scss'],
    imports: [IonIcon]
})
export class MarvFieldComponent  implements OnInit {

    @Input({alias : 'label', required : true}) labelField: string;
    @Input({alias : 'value', required : false, transform: toStringInput}) valueField: string;
    @Input({alias : 'icon', required : false}) iconField: string;
    @Input({alias : 'inline', required : false}) inline: boolean = true;

    constructor() { }

    ngOnInit() {}
    
}
